import { lazy } from 'react'

export const RestaurantWrapperLazy = lazy(() => import('./RestaurantWrapper'))
export const CreateOrderWrapperLazy = lazy(() => import('./CreateOrderWrapper'))
